import { Component, Prop, h, State, EventEmitter, Event } from '@stencil/core';

@Component({
  tag: 'dynamic-form',
  styleUrl: 'dynamic-form.css',
  shadow: true
})
export class DynamicForm {
  @Prop() config: any;

  @State() formData: { [key: string]: any } = {};
  @Event() formSubmit: EventEmitter<any>;

  componentWillLoad() {
    this.setupDefaultFormData();
  }

  setupDefaultFormData() {
    this.formData = {};
    this.config.plcDetails.forEach(plcDetail => {
      plcDetail.datasourceProps.forEach(prop => {
        if (prop.type !== 'group') {
          this.formData[prop.id] = prop.default || '';
        }
        if (prop.type === 'group' && prop.childrenProps) {
          prop.childrenProps.forEach(childProp => {
            this.formData[childProp.id] = childProp.default || childProp.checked || '';
          });
        }
      });
    });
  }

  private handleValueChanged = (event: CustomEvent<{ id: string; value: any }>) => {
    this.formData = {
      ...this.formData,
      [event?.detail?.id]: event?.detail?.value
    };
  };

  renderFormInput(prop) {
    switch (prop.type) {
      case 'text':
      case 'password':
      case 'integer':
      case 'array':
        return (
          <form-input inputValue={prop} onValueChanged={this.handleValueChanged}></form-input>
        );
      case 'checkbox':
        return ( 
          <form-checkbox inputValue={prop} onValueChanged={this.handleValueChanged}></form-checkbox>
        );
      case 'select':
        return (
          <form-select inputValue={prop} onValueChanged={this.handleValueChanged}></form-select>
        );
      case 'file':
        return (
          <form-upload inputValue={prop} onValueChanged={this.handleValueChanged}></form-upload>
        );
      case 'group':
        return (
          <div >
            {prop.label && <label>{prop.label}</label>}
            {prop.childrenProps.map(childProp => this.renderFormInput(childProp))}
          </div>
        )
      default:
        return <span>Unsupported control type</span>;
    }
  }

  getFormData(e) {
    e.preventDefault();
    const formData = this.formData;
    console.log('Form Data from stencil:', formData);
    this.formSubmit.emit(formData);
  }


  render() {
    return (
      <div>
        <form>
          {this.config.plcDetails.map(plc =>
            <fieldset>
              <legend>{plc.plcType}</legend>
              {plc.datasourceProps.map(prop => //datasourceProps //tagsProps
                <div>
                  {this.renderFormInput(prop)}
                </div>
              )}
              <ix-button type="submit" onClick={this.getFormData.bind(this)}>Submit</ix-button>
            </fieldset>
          )}
        </form>

      
      </div>
    );
  }
}
 // for tags form
  // <form>
  //         {this.config.plcDetails.map(plc =>
  //           <fieldset>
  //             <legend>{plc.plcType}</legend>
  //             {plc.tagProps.map(prop => //datasourceProps //tagsProps
  //               <div>
  //                 {/* <label htmlFor={prop.id}>{prop.label || prop.id}</label> */}
  //                 {this.renderFormInput(prop)}
  //               </div>
  //             )}
  //             <ix-button type="submit" onClick={this.getFormData.bind(this)}>Submit</ix-button>
  //           </fieldset>
  //         )}
  //       </form>